import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import './styles.css';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import { Row } from 'react-flexbox-grid'
import Lazyload from 'react-lazyload';
import ArticuloItem from './itemArticulo'
import BusquedaAvanzadaModal from './busquedaAvanzadaModal'
import ArticuloNuevoModal from './articuloNuevoModal'
import InfiniteScroll from "react-infinite-scroll-component";

class ArticuloListado extends React.Component {


    constructor(props) {
        super(props)

        this.state = {

        }
    }



    render() {
        return (
            <div>
                <div>
                    <TitleBar
                        validator="nombre"
                        title={'Artículos'}
                        type='list'
                        searchPlaceholder='Ingrese nombre o código'
                        handleOnSearch={this.props.handleOnSearch}
                        showSearch={true}
                        handleOnNewButton={this.props.handleOnNewButton}
                        handleOnSearchAdvanced={this.props.handleOnSearchAdvanced}
                        filtroArticulo={this.props.filtroArticulo}
                        moduloArticulo
                    />
                </div>

                {/* MODAL BUSQUEDA AVANZADA */}

                <BusquedaAvanzadaModal
                    open={this.props.open}
                    filtros={this.props.filtros}
                    rubros={this.props.rubros}
                    subrubros={this.props.subrubros}
                    superRubros={this.props.superRubros}

                    handleIdSuperRubro={this.props.handleIdSuperRubro}
                    handleIdRubro={this.props.handleIdRubro}
                    handleIdSubRubro={this.props.handleIdSubRubro}
                    handleCloseModal={this.props.handleCloseModal}
                    handleNombreArticulo={this.props.handleNombreArticulo}
                    handleCodigoArticulo={this.props.handleCodigoArticulo}
                    handleOnAdvanceSearch={this.props.handleOnAdvanceSearch}
                    superRubroUnico={this.props.superRubroUnico}
                    validar={this.props.validar}
                    validarNombre={this.props.validarNombre}
                    validarCodigo={this.props.validarCodigo}

                />

                {/* MODAL ARTICULO NUEVO */}

                <ArticuloNuevoModal open={this.props.openNewModal}
                    handleCloseModal={this.props.handleCloseModalNuevo}
                    superRubroUnico={this.props.superRubroUnico}
                    rubroUnico={this.props.rubroUnico}
                    rubros={this.props.rubros}
                    subrubros={this.props.subrubros}
                    superRubros={this.props.superRubros}
                    filtros={this.props.filtros}
                    handleIdSuperRubro={this.props.handleIdSuperRubro}
                    handleIdRubro={this.props.handleIdRubro}
                    handleCreateArticuloFromModal={this.props.handleCreateArticuloFromModal}
                    superRubroValidoModal={this.props.superRubroValidoModal}
                    rubroValidoModal={this.props.rubroValidoModal} />

                <div className='SuperRubro'>
                    {this.props.listadoArticulo !== undefined ? this.props.listadoArticulo.listaSuperRubros.map((sr, srIndex) => {
                        return (

                            <InfiniteScroll
                                dataLength={this.props.currentPage * this.props.pageSize}
                                next={this.props.fetchMoreArticulos}
                                hasMore={this.props.hasMoreArticulos}
                                loader={<h4 style={{ textAlign: "center" }}>Cargando articulos...</h4>}
                                useWindow={false}
                                endMessage={
                                    <p style={{ textAlign: "center" }}>
                                        <b>No hay más artículos.</b>
                                    </p>
                                }
                            >
                                {
                                    sr.listaRubros.map((rub, rubIndex) => {
                                        return (
                                            <div>
                                                <div>{sr.nombre} - {rub.nombre}</div>
                                                <Divider className='divider' />
                                                {
                                                    rub.listaSubRubros.map((itemSubrubro, isIndex) => {
                                                        return (
                                                            <div>
                                                                {itemSubrubro.tieneEntradasActivas ?
                                                                    <div className='stockItemRow'>
                                                                        <div className="subRubros">{itemSubrubro.nombre}</div>
                                                                        <Paper className='containerPaperArticulos'>

                                                                            <Row className='stockItemRowImages'>


                                                                                {itemSubrubro.listaArticulos.map((itemArticulo, iaIndex) => {
                                                                                    return (
                                                                                        <div>
                                                                                            {itemArticulo.activo &&
                                                                                                <Lazyload height={525}>
                                                                                                    <ArticuloItem
                                                                                                        key={itemArticulo.idArticulo}
                                                                                                        idSuperRubro={sr.idSuperRubro}
                                                                                                        isGenerico={(sr.nombre === 'Generico' || sr.nombre === 'Genérico' || sr.idSuperRubro === 2) ? true : false}
                                                                                                        itemArticulo={itemArticulo}
                                                                                                        getImgArticulo={this.props.getImgArticulo}
                                                                                                        handleclick={this.props.handleClickEditarArticulo}
                                                                                                        instalacion={this.props.instalacion}
                                                                                                    />
                                                                                                </Lazyload>
                                                                                            }
                                                                                        </div>
                                                                                    )
                                                                                })}

                                                                            </Row>

                                                                        </Paper>
                                                                    </div> : ''}
                                                            </div>
                                                        )
                                                    })}
                                            </div>
                                        )
                                    })

                                }
                            </InfiniteScroll>

                        )
                    }) : ''}
                </div>


            </div>
        )
    }
}



ArticuloListado.propTypes = {
    handleOnSearchAdvanced: PropTypes.func.isRequired,
    handleOnSearch: PropTypes.func.isRequired,
    listadoArticulo: PropTypes.object.isRequired,
    hasMoreArticulos: PropTypes.bool.isRequired,
    fetchMoreArticulos: PropTypes.func.isRequired,
    getImgArticulo: PropTypes.func.isRequired,
    handleClickEditarArticulo: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    superRubros: PropTypes.array.isRequired,
    rubros: PropTypes.array.isRequired,
    subrubros: PropTypes.array.isRequired,
    filtros: PropTypes.object.isRequired,
    handleIdSuperRubro: PropTypes.func.isRequired,
    handleIdRubro: PropTypes.func.isRequired,
    handleIdSubRubro: PropTypes.func.isRequired,
    handleCloseModal: PropTypes.func.isRequired,
    handleNombreArticulo: PropTypes.func.isRequired,
    handleCodigoArticulo: PropTypes.func.isRequired,
    handleOnAdvanceSearch: PropTypes.func.isRequired,
    superRubroUnico: PropTypes.bool.isRequired,
    rubroUnico: PropTypes.bool.isRequired,
    validar: PropTypes.func.isRequired,
    validarNombre: PropTypes.func.isRequired,
    validarCodigo: PropTypes.func.isRequired,
    openNewModal: PropTypes.func.isRequired,
    handleOnNewButton: PropTypes.func.isRequired,
    handleCloseModalNuevo: PropTypes.func.isRequired,
    handleCreateArticuloFromModal: PropTypes.func.isRequired,
    superRubroValidoModal: PropTypes.bool.isRequired,
    rubroValidoModal: PropTypes.bool.isRequired,
    currentPage: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    filtroArticulo: PropTypes.string,
    instalacion: PropTypes.object
}

ArticuloListado.defaultProps = {

}

export default ArticuloListado